import React, { PropsWithChildren, createContext, useState } from "react";
import { AttributeContextType, TEditingItemAttribute, TdeleteInfo } from "./types";


export const AttributeContext = createContext<AttributeContextType>({} as AttributeContextType);

export const AttributeContextProvider = ({ children }: PropsWithChildren) => {
  let [listReloadCounter, setListReloadCounter] = React.useState<number>(0);
  let [editingItem, setEditingItem] = React.useState<TEditingItemAttribute|null>(null);
  let [deleteinfo, setDeleteInfo] = useState<TdeleteInfo>({
    status: null,
    message: "",
  });
  const [attributeId, setAttributeId] = useState<string>("");
  const [newAttributeId, setNewAttributeId] = useState<string>("");
  const [updatedAttributeId, setUpdatedAttributeId] = useState<string>("");
  const [attributeDeleted, setAttributeDeleted] = useState<boolean>(false);
  const [attributeLoading, setAttributeLoading] = useState<boolean>(false)
  // True while the right-hand pane is fetching one attribute's details. Separate from
  // attributeLoading, which the attribute-VALUES components already use for their own button
  // disabling -- sharing one flag would let either fetch's completion clear the other's.
  const [detailLoading, setDetailLoading] = useState<boolean>(false)

  return (
    <AttributeContext.Provider
      value={{
        listReloadCounter,
        editingItem,
        setEditingItem,
        setListReloadCounter,
        deleteinfo,
        setDeleteInfo,
        attributeId,
        setAttributeId,
        newAttributeId,
        setNewAttributeId,
        updatedAttributeId,
        setUpdatedAttributeId,
        attributeDeleted,
        setAttributeDeleted,
        attributeLoading,
        setAttributeLoading,
        detailLoading,
        setDetailLoading
      }}
    >
      {children}
    </AttributeContext.Provider>
  );
};
